import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";

/**
 * Utilizar el servicio para obtener las notificaciones de un cliente
 * @returns Archivo de guia
 */
export async function GetClientNotifications(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `notifications/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Utilizar el servicio para leer las notificaciones de un cliente
 * @returns Archivo de guia
 */
export async function ReadClientNotifications(data) {
  const token = await getToken();
  return axios({
    method: "PUT",
    data: data,
    url: `notifications`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Utilizar el servicio para obtener las alarmas de un cliente
 * @returns Archivo de guia
 */

export async function GetClientAlarms(data) {
  const token = await getTokenMicro();
  return axios({
    method: "POST",
    data: data,
    url: `businessalarms`,
    baseURL: env.REACT_APP_API_URL_BUSINESSALARMS,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Utilizar el servicio para leer las alarmas de un cliente
 * @returns Archivo de guia
 */

export async function ReadClientAlarms(data) {
  const token = await getTokenMicro();
  return axios({
    method: "PUT",
    data: data,
    url: `businessalarms`,
    baseURL: env.REACT_APP_API_URL_BUSINESSALARMS,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
